import gql from 'graphql-tag';

import client from '../graphqlAPI';

const GET_PAYMENTS_LIST = gql`
query getUnregisteredPayments($email: String, $fullName: String, $purchaseId: String, $provider: String, $startDate: String, $finishDate: String, $from: Int, $to: Int, $sortingField: String, $sortingType: Int, $getTotal: Boolean) {
  getUnregisteredPayments(email: $email, fullName: $fullName, purchaseId: $purchaseId, provider: $provider, startDate: $startDate, finishDate: $finishDate, from: $from, to: $to, sortingField: $sortingField, sortingType: $sortingType, getTotal: $getTotal) {
      isAuth
      total
      query
      payments {
        _id
        provider
        datePayment
        paypalAccountId
        transactionId
        purchaseId
        currency
        amount
        transactionStatus
        transactionSubject
        providerEmail
        fullName
        country
        createdAt
      }
    }
  }
`;

const getUnregisteredPayments = async (variables) => {
  try {
    const result = await client
      .query({
        query: GET_PAYMENTS_LIST,
        variables,
        errorPolicy: 'all',
        fetchResults: true,
        fetchPolicy: 'no-cache',
      })
      .then(queryResult => queryResult)
      .catch((queryError) => {
        console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: Apollo Client Query Error: ${queryError}`);
        return null;
      });
    const {
      data: { getUnregisteredPayments: getUnregisteredPaymentsData },
    } = result;

    if (getUnregisteredPaymentsData) {
      return getUnregisteredPaymentsData;
    }
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: GraphQL Query Error: getUnregisteredPayments`);
    return null;
  } catch (error) {
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: getUnregisteredPayments Error: ${error}`);
    return null;
  }
};

export default getUnregisteredPayments;
